import 'react-dom';

import LoginBanner from 'login/components/LoginBanner/LoginBanner.jsx';
import GuestOrSignin from 'login/components/GuestOrSignin/GuestOrSignin.jsx';
import LoginBannerContainer from 'login/components/LoginBannerContainer/LoginBannerContainer.jsx';
import Profile from 'login/components/Profile/ProfileModal.jsx';

import LocalConfigsService from 'login/services/ConfigsService/ConfigsService.js';
import TokenService from 'login/services/TokenService/TokenService.js';
import LoginLightService from 'login/services/LoginLightService/LoginLightService.js';

import * as MODALS from 'login/constants/modalNames.js';

const root = LoginBanner;
const provider = LoginBannerContainer;
const main = provider;

const services = {
    LocalConfigsService,
    TokenService,
    LoginLightService,
};

export const widgets = {
    Login: {
        components: {
            root,
            provider,
            main,
            Profile,
            GuestOrSignin,
        },
        services,
        constants: { MODALS },
    },
};

export default {
    root,
    provider,
    Login: main,
    MODALS,
    GuestOrSignin,
};
